import type { RegistryFieldDiff } from '../types';

interface DiffListProps {
  diffs: RegistryFieldDiff[];
  emptyMessage?: string;
}

function renderValue(value: unknown): string {
  if (value === null) return 'null';
  if (value === undefined) return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function DiffList({ diffs, emptyMessage = 'No differences' }: DiffListProps) {
  if (diffs.length === 0) {
    return <p className="text-xs text-gray-500 italic">{emptyMessage}</p>;
  }
  return (
    <div className="space-y-2">
      {diffs.map(d => (
        <div key={d.field} className="text-xs">
          <div className="font-mono text-gray-300 mb-1">{d.field}</div>
          <div className="grid grid-cols-2 gap-2">
            <div className="bg-red-950/30 border border-red-900/40 rounded px-2 py-1 overflow-hidden">
              <div className="text-[10px] uppercase text-red-400/70 mb-0.5">before</div>
              <pre className="whitespace-pre-wrap break-words text-red-200 font-mono">
                {renderValue(d.before)}
              </pre>
            </div>
            <div className="bg-emerald-950/30 border border-emerald-900/40 rounded px-2 py-1 overflow-hidden">
              <div className="text-[10px] uppercase text-emerald-400/70 mb-0.5">after</div>
              <pre className="whitespace-pre-wrap break-words text-emerald-200 font-mono">
                {renderValue(d.after)}
              </pre>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
